import React, {Component} from 'react';

const percent = (probability) => {
    return (probability * 100).toFixed(0);
}

export {percent};